export default {
  text: "hogehoge"
}